import { render, staticRenderFns } from "./Crisis_statistics_unit.vue?vue&type=template&id=0c34da39&style=height%3A%20100%25"
import script from "./Crisis_statistics_unit.vue?vue&type=script&lang=js"
export * from "./Crisis_statistics_unit.vue?vue&type=script&lang=js"
import style0 from "./Crisis_statistics_unit.vue?vue&type=style&index=0&id=0c34da39&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports